module.exports = __webpack_public_path__ + "images/ded0213b5e77e493bebec46de9788aff.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Shell/scenes/Header/img/free_spirit_agg_logo.png
// module id = 1259
// module chunks = 0